import Chapter from "@/components/Chapter";
import Reveal from "@/components/Reveal";
import { SERVICES } from "@/data/content";

const About = () => (
  <section id="about" data-testid="about-section" className="bg-white py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
      <div className="lg:sticky lg:top-28 lg:self-start">
        <Chapter
          index="01"
          eyebrow="About the House"
          title="A family at the loom since 1991."
        />
        <Reveal delay={0.15} className="mt-10 hidden lg:block">
          <div className="border border-gold/30 bg-cream p-8">
            <p className="font-serif text-2xl italic leading-snug text-navy">
              "We weave fabric — and we have spent three decades weaving it well."
            </p>
            <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.3em] text-royal">The founding family</p>
          </div>
        </Reveal>
      </div>

      <div>
        <Reveal className="space-y-6 text-base leading-relaxed text-slate-600">
          <p>
            P.A. International was founded by Mr. Anand Kumar Nathani in Bhagalpur, Bihar — a town
            whose name has been synonymous with silk weaving for centuries. For three decades now,
            what began as a handloom workshop has grown into an export house trusted by fashion and
            home décor buyers across Europe, the USA, Canada, Australia, Japan and the Gulf.
          </p>
          <p>
            At the heart of our business is our own handloom mill, run by weavers whose craft has
            been passed down and refined over years at the loom. Their experience and deep knowledge
            of the craftsmanship shape every piece of fabric we send out — the texture, the
            hand-feel, the consistency a buyer can rely on order after order.
          </p>
          <p>
            We work directly with our own weaving units, which means quality, timelines and pricing
            stay in our hands rather than passing through layers of intermediaries. Every order —
            from a first development swatch to a full container of bulk fabric — is overseen by a
            dedicated team handling production, documentation and logistics through our Bhagalpur
            mill and Kolkata despatch office.
          </p>
          <p>
            Three decades in, our approach hasn't changed: honest sourcing, fabric that matches the
            sample you approved, and a team that picks up the phone when you call.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-10">
          <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-royal">In-house services</p>
          <div className="mt-4 flex flex-wrap gap-3">
            {SERVICES.map((s) => (
              <span
                key={s}
                data-testid={`service-chip-${s.toLowerCase().replace(/\s+/g, "-")}`}
                className="border border-navy/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.15em] text-navy transition-colors hover:border-gold hover:text-gold"
              >
                {s}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="mt-12 grid gap-px bg-navy/10 sm:grid-cols-2">
          {[
            ["Founder", "Mr. Anand Kumar Nathani"],
            ["Partner", "Mr. Paritosh Nathani — Social Media & Marketing Head"],
            ["Handloom", "Experienced weavers, deep craft knowledge"],
            ["Direct", "Mill-to-buyer pricing, no intermediaries"],
          ].map(([v, l]) => (
            <div
              key={l}
              data-testid={`about-detail-${v.toLowerCase().replace(/\s+/g, "-").replace("+", "plus")}`}
              className="bg-white p-6"
            >
              <div className="font-serif text-3xl font-semibold text-navy">{v}</div>
              <div className="mt-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">{l}</div>
            </div>
          ))}
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
